import styled from "styled-components/macro"
import SingleSelectSimple from "../../../../Ui/Form/SingleSelectSimple"

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  align-items: center;
  margin: 1rem 0;

  ${(p) => p.theme.mQ.MEDIA_MIN_MEDIUM} {
    grid-template-columns: 1fr;
  }
`

export const Label = styled.h4`
  margin: 0;
`

export const AddedReason = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;

  span {
    margin-right: 1rem;
  }

  svg {
    height: 1.6rem;

    &:hover {
      cursor: pointer;
      fill: ${(p) => p.theme.colors.grey};
    }
  }
`

export const Wrapper = styled.div`
  margin-bottom: 2rem;
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  padding: 1rem 1rem 2rem 1rem;
  border-radius: 0.6rem;
  background: ${(p) => p.theme.colors.background};
`

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;

  svg {
    height: 1.6rem;
    margin-right: 1rem;
  }

  &:hover {
    cursor: pointer;
  }
`

export const TaxWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  div[class*="-control"] {
    height: 4.5rem;
  }
`

export const StyledSelect = styled(SingleSelectSimple)`
  div[class*="-singleValue"] {
    padding-left: 1rem;
  }
`
